import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { PaginatedResponseData } from '@hcs/types';

import { ViewOrderApi } from '../api/viewOrderApi';
import { OrderItem, OrderItemsParams } from '../types';

export const QUERY_KEY_ORDER_ITEMS = 'order-items';
export const useOrderItems = (
  orderId: number,
  params: OrderItemsParams,
  options?: Partial<
    UseQueryOptions<
      PaginatedResponseData<OrderItem[]>,
      AxiosError,
      PaginatedResponseData<OrderItem[]>,
      [typeof QUERY_KEY_ORDER_ITEMS, number, OrderItemsParams | undefined]
    >
  >,
) => {
  return useQuery({
    queryKey: [QUERY_KEY_ORDER_ITEMS, orderId, params],

    queryFn: async ({ signal }) => {
      return ViewOrderApi.fetchOrderItems(orderId, params, signal);
    },

    ...options,
  });
};
